// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/sitting-women-character.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/standing-man.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/images/coverage-set-icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/images/why-choose-icons.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Heading {
  font-size: 34px;
  line-height: 50px;
}
.container{
  max-width:100% !important
}
.btn-primary-bg {
  background-color: var(--theme-blue-color);
}
.BannerSection {
  background-color: var(--theme-gray-bg);
  padding: 65px 0;
}
.BannerContent {
  min-height: 385px;
}
.btn.btn-outline-primary {
  border: 1px solid var(--theme-blue-color);
  color: var(--theme-blue-color);
}
.btn.btn-outline-primary:hover {
  color: #013ade;
  border-color: #013ade;
}
.CommonSection {
  padding: 65px 0;
}
.WhyStar {
  background: rgb(236, 240, 251);
  background: linear-gradient(
    120deg,
    rgba(236, 240, 251, 1) 0%,
    rgba(239, 216, 239, 1) 49%,
    rgba(204, 245, 252, 1) 100%
  );
}
.CustomCards {
  box-shadow: 0px 0px 29px rgba(0, 0, 0, 0.16);
}
.CardImage {
  background-color: #f6f8ff;
  border-radius: 10px 10px 0 0;
}
.RoundedTR10,
.card.RoundedTR10 {
  border-radius: 10px 10px 0 0;
}
.CustomCards .card-text {
  min-height: 110px;
}
.CoverageListSection {
  border: 1px solid #4a4a4a;
  border-bottom: 0px;
}
.CoverageListSection::before,
.CoverageListSection::after,
.ContentList::before,
.ContentList::after {
  content: "";
  position: absolute;
}
.CoverageListSection::before {
  bottom: -1px;
  left: -17%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  width: 195px;
  height: 222px;
}
.CoverageListSection::after {
  bottom: -3px;
  right: -14%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  width: 160px;
  height: 320px;
}
.DisplaySection {
  background-color: #f3f3f3;
}
.DisplaySection span {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 2px solid #4a4a4a;
}
.BadgeLiteBlue {
  background: var(--theme-gray-bg) url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 330px;
  width: 70px;
  height: 70px;
}
.BadgeIcon_1 {
  background-position: 10px 11px;
}
.BadgeIcon_3 {
  background-position: -48px 11px;
}
.BadgeIcon_4 {
  background-position: -124px 11px;
}
.BadgeIcon_5 {
  background-position: -194px 11px;
}
.BadgeIcon_6 {
  background-position: -275px 11px;
}
.Rounded10,
.badge.Rounded10,
.SmallCard.Rounded10 {
  border-radius: 10px;
}
.EmptyBlueSpace {
  height: 25px;
  background-color: var(--theme-blue-color);
}
.ContentList::before,
.ContentList::after {
  top: 5px;
  left: -5px;
  border-radius: 50%;
}
.ContentList::before {
  width: 16px;
  height: 16px;
  z-index: 1;
  background-color: var(--theme-blue-color);
}
.ContentList::after {
  width: 25px;
  height: 25px;
  left: -10px;
  top: 0;
  transform: scale(1);
  animation: pulse-black 2s infinite;
  z-index: 0;
}
.font-italic {
  font-family: "Manrope";
  font-style: italic;
}
.CustomCardTransparent {
  background-color: rgba(255, 255, 255, 0.43);
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.16);
}
.CustomCardTransparent img {
  width: 52px;
  height: 52px;
}
.Rounded20 {
  border-radius: 20px;
}
.SmallCard {
  box-shadow: 0px 3px 0px rgba(0, 0, 0, 0.16);
}
.SmallCardIcon {
  width: 45px;
  height: 45px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 260px;
}
.SmallCardIcon_1 {
  background-position: 4px -44px;
}
.SmallCardIcon_2 {
  background-position: -101px 4px;
}
.SmallCardIcon_3 {
  background-position: -47px -44px;
}
.SmallCardIcon_4 {
  background-position: -115px -51px;
  background-size: 295px;
}
.WhyChooseCard img {
  width: 70px;
  height: 70px;
}
.WhyChooseCard {
  box-shadow: 0px -3px 20px rgba(0, 0, 0, 0.16);
}
.TextDarkBlue {
  color: #013ade;
}
.WhyChooseCard h5 {
  min-height: 110px;
}

@keyframes pulse-black {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(53, 71, 137, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(53, 71, 137, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(53, 71, 137, 0);
  }
}

.BoardDetails {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
}
.z-1 {
  z-index: 1;
}
.w-100.w-sm-75,
.w-sm-75 {
  width: 75% !important;
}
.WhyChooseIcons {
  width: 70px;
  height: 70px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  background-size: 325px;
}
.WhyChooseIcon_1 {
  background-position: 0px 0px;
}
.WhyChooseIcon_2 {
  background-position: -88px 0px;
}
.WhyChooseIcon_3 {
  background-position: -177px 0px;
}
.WhyChooseIcon_4 {
  background-position: -255px 0px;
}

/********* Mobile responsive *********/
@media screen and (max-width: 767px) {
  .BoardDetails {
    position: static;
  }
  .CoverageListSection::after,
  .CoverageListSection::before {
    display: none;
  }
  .Heading {
    font-size: 24px;
    line-height: 26px;
  }
  .h5,
  h5 {
    font-size: 1rem !important;
  }
  .CommonSection,
  .BannerSection {
    padding: 35px 0;
  }
  .WhyChooseCard h5,
  .CustomCards .card-text {
    min-height: auto;
  }
  .MainPageSection {
    max-height: inherit !important;
  }
}

.mg-bt-40 {
  margin-bottom: 40px;
}
.BadgeDashboardIcon {
  background-position: -207px -61px;
  width: 46px;
  height: 46px;
}
.BadgeLogoutIcon {
  background-position: -254px -62px;
  width: 46px;
  height: 46px;
}
`, "",{"version":3,"sources":["webpack://./src/homepage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;AACF;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B;;;;;GAKC;AACH;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;;;EAIE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,UAAU;EACV,6DAAuE;EACvE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,6DAA4D;EAC5D,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,wEAA6E;EAC7E,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,yCAAyC;AAC3C;AACA;;EAEE,QAAQ;EACR,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,MAAM;EACN,mBAAmB;EACnB,kCAAkC;EAClC,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,YAAY;EACZ,mDAAwD;EACxD,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6DAAgE;EAChE,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;AAEA,sCAAsC;AACtC;EACE;IACE,gBAAgB;EAClB;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd","sourcesContent":[".Heading {\n  font-size: 34px;\n  line-height: 50px;\n}\n.container{\n  max-width:100% !important\n}\n.btn-primary-bg {\n  background-color: var(--theme-blue-color);\n}\n.BannerSection {\n  background-color: var(--theme-gray-bg);\n  padding: 65px 0;\n}\n.BannerContent {\n  min-height: 385px;\n}\n.btn.btn-outline-primary {\n  border: 1px solid var(--theme-blue-color);\n  color: var(--theme-blue-color);\n}\n.btn.btn-outline-primary:hover {\n  color: #013ade;\n  border-color: #013ade;\n}\n.CommonSection {\n  padding: 65px 0;\n}\n.WhyStar {\n  background: rgb(236, 240, 251);\n  background: linear-gradient(\n    120deg,\n    rgba(236, 240, 251, 1) 0%,\n    rgba(239, 216, 239, 1) 49%,\n    rgba(204, 245, 252, 1) 100%\n  );\n}\n.CustomCards {\n  box-shadow: 0px 0px 29px rgba(0, 0, 0, 0.16);\n}\n.CardImage {\n  background-color: #f6f8ff;\n  border-radius: 10px 10px 0 0;\n}\n.RoundedTR10,\n.card.RoundedTR10 {\n  border-radius: 10px 10px 0 0;\n}\n.CustomCards .card-text {\n  min-height: 110px;\n}\n.CoverageListSection {\n  border: 1px solid #4a4a4a;\n  border-bottom: 0px;\n}\n.CoverageListSection::before,\n.CoverageListSection::after,\n.ContentList::before,\n.ContentList::after {\n  content: \"\";\n  position: absolute;\n}\n.CoverageListSection::before {\n  bottom: -1px;\n  left: -17%;\n  background: url(../public/images/sitting-women-character.svg) no-repeat;\n  width: 195px;\n  height: 222px;\n}\n.CoverageListSection::after {\n  bottom: -3px;\n  right: -14%;\n  background: url(../public/images/standing-man.svg) no-repeat;\n  width: 160px;\n  height: 320px;\n}\n.DisplaySection {\n  background-color: #f3f3f3;\n}\n.DisplaySection span {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  border: 2px solid #4a4a4a;\n}\n.BadgeLiteBlue {\n  background: var(--theme-gray-bg) url(../public/images/coverage-set-icons.svg);\n  background-repeat: no-repeat;\n  background-size: 330px;\n  width: 70px;\n  height: 70px;\n}\n.BadgeIcon_1 {\n  background-position: 10px 11px;\n}\n.BadgeIcon_3 {\n  background-position: -48px 11px;\n}\n.BadgeIcon_4 {\n  background-position: -124px 11px;\n}\n.BadgeIcon_5 {\n  background-position: -194px 11px;\n}\n.BadgeIcon_6 {\n  background-position: -275px 11px;\n}\n.Rounded10,\n.badge.Rounded10,\n.SmallCard.Rounded10 {\n  border-radius: 10px;\n}\n.EmptyBlueSpace {\n  height: 25px;\n  background-color: var(--theme-blue-color);\n}\n.ContentList::before,\n.ContentList::after {\n  top: 5px;\n  left: -5px;\n  border-radius: 50%;\n}\n.ContentList::before {\n  width: 16px;\n  height: 16px;\n  z-index: 1;\n  background-color: var(--theme-blue-color);\n}\n.ContentList::after {\n  width: 25px;\n  height: 25px;\n  left: -10px;\n  top: 0;\n  transform: scale(1);\n  animation: pulse-black 2s infinite;\n  z-index: 0;\n}\n.font-italic {\n  font-family: \"Manrope\";\n  font-style: italic;\n}\n.CustomCardTransparent {\n  background-color: rgba(255, 255, 255, 0.43);\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.16);\n}\n.CustomCardTransparent img {\n  width: 52px;\n  height: 52px;\n}\n.Rounded20 {\n  border-radius: 20px;\n}\n.SmallCard {\n  box-shadow: 0px 3px 0px rgba(0, 0, 0, 0.16);\n}\n.SmallCardIcon {\n  width: 45px;\n  height: 45px;\n  background: url(../public/images/coverage-set-icons.svg);\n  background-repeat: no-repeat;\n  background-size: 260px;\n}\n.SmallCardIcon_1 {\n  background-position: 4px -44px;\n}\n.SmallCardIcon_2 {\n  background-position: -101px 4px;\n}\n.SmallCardIcon_3 {\n  background-position: -47px -44px;\n}\n.SmallCardIcon_4 {\n  background-position: -115px -51px;\n  background-size: 295px;\n}\n.WhyChooseCard img {\n  width: 70px;\n  height: 70px;\n}\n.WhyChooseCard {\n  box-shadow: 0px -3px 20px rgba(0, 0, 0, 0.16);\n}\n.TextDarkBlue {\n  color: #013ade;\n}\n.WhyChooseCard h5 {\n  min-height: 110px;\n}\n\n@keyframes pulse-black {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(53, 71, 137, 0.7);\n  }\n\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(53, 71, 137, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(53, 71, 137, 0);\n  }\n}\n\n.BoardDetails {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 0;\n}\n.z-1 {\n  z-index: 1;\n}\n.w-100.w-sm-75,\n.w-sm-75 {\n  width: 75% !important;\n}\n.WhyChooseIcons {\n  width: 70px;\n  height: 70px;\n  background: url(../public/images/why-choose-icons.svg) no-repeat;\n  background-size: 325px;\n}\n.WhyChooseIcon_1 {\n  background-position: 0px 0px;\n}\n.WhyChooseIcon_2 {\n  background-position: -88px 0px;\n}\n.WhyChooseIcon_3 {\n  background-position: -177px 0px;\n}\n.WhyChooseIcon_4 {\n  background-position: -255px 0px;\n}\n\n/********* Mobile responsive *********/\n@media screen and (max-width: 767px) {\n  .BoardDetails {\n    position: static;\n  }\n  .CoverageListSection::after,\n  .CoverageListSection::before {\n    display: none;\n  }\n  .Heading {\n    font-size: 24px;\n    line-height: 26px;\n  }\n  .h5,\n  h5 {\n    font-size: 1rem !important;\n  }\n  .CommonSection,\n  .BannerSection {\n    padding: 35px 0;\n  }\n  .WhyChooseCard h5,\n  .CustomCards .card-text {\n    min-height: auto;\n  }\n  .MainPageSection {\n    max-height: inherit !important;\n  }\n}\n\n.mg-bt-40 {\n  margin-bottom: 40px;\n}\n.BadgeDashboardIcon {\n  background-position: -207px -61px;\n  width: 46px;\n  height: 46px;\n}\n.BadgeLogoutIcon {\n  background-position: -254px -62px;\n  width: 46px;\n  height: 46px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
